export enum FileTypes {
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  word = 'application/msword',
  xls  = 'application/excel',
  pdf  = 'application/pdf',
  txt  = 'text/plain',
  csv  = 'text/x-comma-separated-values',
  json = 'application/json'
}